const { appApiUrl } = require('./api-url');

async function billingRequest(user, path, options = {}) {
  const token = await user.getIdToken();
  const response = await fetch(`${appApiUrl}${path}`, {
    ...options,
    headers: {
      authorization: `Bearer ${token}`,
      ...(options.headers || {})
    }
  });
  const result = await response.json();
  if (!response.ok) {
    throw new Error(result.error || 'Unable to load billing information');
  }
  return result;
}

function loadBillingSummary(user) {
  return billingRequest(user, '/api/billing/summary');
}

function loadBillingAccess(user) {
  return billingRequest(user, '/api/billing/access');
}

function startBillingCheckout(user) {
  return billingRequest(user, '/api/billing/checkout', { method: 'POST' });
}

function cancelBilling(user) {
  return billingRequest(user, '/api/billing/cancel', { method: 'POST' });
}

function openBillingPortal(user) {
  return billingRequest(user, '/api/billing/portal', { method: 'POST' });
}

function loadMcpTokenStatus(user) {
  return billingRequest(user, '/api/account/mcp-token');
}

function createMcpToken(user) {
  return billingRequest(user, '/api/account/mcp-token', { method: 'POST' });
}

function revokeMcpToken(user) {
  return billingRequest(user, '/api/account/mcp-token', { method: 'DELETE' });
}

module.exports = {
  cancelBilling,
  createMcpToken,
  loadBillingAccess,
  loadBillingSummary,
  loadMcpTokenStatus,
  openBillingPortal,
  revokeMcpToken,
  startBillingCheckout
};
